import useCurrentLoginUserInfo from '@/hooks/useCurrentLoginUserInfo';
import useThemeToken from '@/hooks/useTheme';
import { useLocales } from '@/Locales';
import { switchOrganize } from '@/services/common';
import { useCacheTab } from '@/store/cacheTab';
import { setToken } from '@/utils/cookies';
import { Dropdown } from '@sinohealth/butterfly-ui-components';
import { useAliveController } from 'react-activation';
import { useNavigate } from 'react-router-dom';
import styles from './index.less';

const Team = () => {
  const themeToken = useThemeToken();
  const [userInfo, isError, reloadUserInfo] = useCurrentLoginUserInfo();
  const { clearTabs } = useCacheTab();
  const { clear } = useAliveController();
  const { t } = useLocales();
  const navigate = useNavigate();
  const options = userInfo.agencys?.map((agencyItem: any) => {
    return {
      key: agencyItem.organizeId,
      label: agencyItem.organizeName,
      value: agencyItem.organizeId,
    };
  });

  const handleChangeTeam = (e: any) => {
    // setUserInfo({
    //   ...userInfo,
    //   agency: userInfo.agencys.filter((item: any) => item.organizeId === agencyId)[0] || {},
    // });
    switchOrganize({
      organizeId: e.key,
    }).then(async (token: string) => {
      setToken(token);
      reloadUserInfo && (await reloadUserInfo());
      setTimeout(() => {
        clearTabs();
        clear();
      }, 0);
      navigate('/');
    });
  };

  if (options.length <= 1) {
    return null;
  }

  return (
    <Dropdown menu={{ items: options, onClick: handleChangeTeam }}>
      <div className={styles.team} style={{ background: themeToken.colorBgBase }}>
        <div className={styles.left} style={{ color: themeToken.colorTextSecondary }}>
          {t('项目')}:
        </div>
        <div className={styles.right}>
          {
            userInfo.agencys?.find(
              (item: any) => item.organizeId === userInfo?.employee?.organizeId,
            )?.organizeName
          }
          <span
            className="iconfont icon-arrow-down-s-line"
            style={{ color: themeToken.colorTextSecondary }}
          />
          {/* <Select
            onSelect={handleChangeTeam}
            value={userInfo.employee.organizeId}
            style={{ color: themeToken.colorText }}
            dropdownMatchSelectWidth={false}
            bordered={false}
            suffixIcon={
              <span
                className="iconfont icon-arrow-down-s-line"
                style={{ color: 'rgba(11, 33, 69, 0.65)', pointerEvents: 'none' }}
              />
            }
            options={options}
          /> */}
        </div>
      </div>
    </Dropdown>
  );
};

export default Team;
